<template>
  <div class="pushSettings" v-loading="loading">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="120px"
      class="demo-ruleForm"
    >
      <el-form-item
        label="推送人数"
        prop="sendAuthorCount"
        class="pushSettings__sendAuthorCount"
        v-if="showSendAuthorCount"
      >
        <el-input-number
          v-model="ruleForm.sendAuthorCount"
          :step="100"
          :max="pushTypeConfig.max"
          :min="1"
        ></el-input-number>
        <span class="pushSettings__tips">
          说明：{{ pushTypeConfig.tips }}
        </span>
      </el-form-item>
      <el-form-item
        v-if="!isMedicalAssociationEnv"
        label="论文时间范围"
        prop="articleYearFilter"
      >
        近
        <el-input-number
          style="width: 80px"
          v-model="ruleForm.articleYearFilter"
          :min="1"
          :max="maxYears"
          :step="1"
          :precision="0"
          :controls="false"
        ></el-input-number>
        年
      </el-form-item>
      <el-form-item
        v-if="!isMedicalAssociationEnv"
        label="推送期刊范围"
        prop="magIncludeFilter"
      >
        <el-checkbox-group v-model="magIncludeFilter">
          <el-checkbox
            v-for="item in allMagFilterOptions"
            :title="item.fullName"
            :key="item.id"
            :label="item"
            >{{ item.name }}</el-checkbox
          >
        </el-checkbox-group>
      </el-form-item>
      <el-form-item
        v-if="!isMedicalAssociationEnv"
        label="期刊中信所分类"
        prop="zxsFilter"
      >
        <el-input v-model="ruleForm.zxsFilter"></el-input>
        <p class="tips">注：请使用英文分号“;”隔开</p>
      </el-form-item>
      <el-form-item
        v-if="!isMedicalAssociationEnv"
        label="学者中图分类"
        prop="bookFilter"
      >
        <el-cascader
          :key="bookCascaderKey"
          style="width: 710px;"
          v-model="bookCascaderValue"
          :options="bookFilterOptions"
          :props="bookCascaderProps"
          clearable
          :show-all-levels="false"
          placeholder="请选择中图分类"
        ></el-cascader>
      </el-form-item>
      <el-form-item
        v-if="isMedicalAssociationEnv"
        label="自定义学科"
        prop="customSubjects"
      >
        <subject-selection
          v-model="customSubjects"
          value-field="name"
          label-field="name"
          @root-loaded="handleSubjectRootLoaded"
        />
      </el-form-item>

      <el-form-item label="自定义关键词" prop="customKeywords">
        <el-input v-model="ruleForm.customKeywords"></el-input>
        <p class="tips">注：请使用英文分号“;”隔开</p>
      </el-form-item>

      <el-form-item
        v-if="isMedicalAssociationEnv"
        label="自定义单位"
        prop="organizations"
      >
        <el-input v-model="ruleForm.organizations"></el-input>
        <p class="tips">注：请使用英文分号“;”隔开</p>
      </el-form-item>

      <el-form-item
        v-if="isMedicalAssociationEnv"
        label="自定义科室"
        prop="departments"
      >
        <el-input v-model="ruleForm.departments"></el-input>
        <p class="tips">注：请使用英文分号“;”隔开</p>
      </el-form-item>

      <el-form-item
        v-if="isMedicalAssociationEnv"
        label="自定义职称"
        prop="level1Title"
      >
        <el-cascader
          :key="cascaderKey"
          style="width: 710px;"
          v-model="titleCascaderValue"
          :options="titleCascaderOptions"
          :props="titleCascaderProps"
          clearable
          :show-all-levels="false"
          placeholder="请选择职称"
        ></el-cascader>
      </el-form-item>

      <el-form-item
        v-if="isMedicalAssociationEnv"
        label="自定义职务"
        prop="positions"
      >
        <el-input v-model="ruleForm.positions"></el-input>
        <p class="pushSettings__tips">注:请使用英文分号";"间隔开</p>
      </el-form-item>

      <el-form-item
        label="导入学者："
        v-if="showImportScholar && !isMedicalAssociationEnv"
      >
        <div class="upload-demo">
          <el-upload
            class="upload-demo"
            :http-request="handleImportScholar"
            :show-file-list="false"
            accept=".xlsx,.xls"
            action="."
          >
            <el-button icon="el-icon-download">导入学者</el-button>
          </el-upload>
          <el-button type="text" @click="downloadTemplate">下载模板</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import SubjectSelection from '@/components/subject/Subject.vue'

import { mapGetters } from 'vuex'
import { Get, Post, ProjectConfig } from '@/api'
const increment = ProjectConfig.increment
export default {
  name: 'PushSettings',
  props: {
    historyId: {
      type: String || Number,
      default: ''
    },
    subjectId: {
      type: String || Number,
      default: ''
    },
    taskType: {
      type: String || Number,
      default: ''
    },
    showImportScholar: {
      type: Boolean,
      default: true
    },
    showSendAuthorCount: {
      type: Boolean,
      default: true
    },
    defaultPushType: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      ruleForm: {
        zxsFilter: '', // 期刊中信所分类
        bookFilter: [], // 学者中图书分类（数组格式）
        articleYearFilter: 5, // 推送论文年份
        sendAuthorCount: 10000, // 推送人数（默认值，按推送类型动态调整）
        customKeywords: '', // 自定义关键词
        customSubjects: '', // 自定义学科
        organizations: '', // 自定义单位
        departments: '', // 自定义科室
        level1Title: '', // 自定义一级职称
        level2Title: '', // 自定义二级职称
        positions: '' // 自定义职务
      },
      rules: {},
      titleCascaderValue: [], // 级联选择器的值
      titleCascaderOptions: [], // 级联选择器的选项
      levelTitle: [], // 职称数据，格式为 [{ level1Title: '1', level2Title: '11,12,13' }]
      cascaderKey: 0, // 级联选择器的key，用于强制重新渲染
      bookCascaderKey: 0, // 中图分类级联选择器的key
      bookCascaderValue: [], // 中图分类级联选择器的值
      customSubjects: [],
      // 学科级联根节点 name（替代写死的 'father' 占位符），由 Subject 的 root-loaded 事件赋值
      subjectRootName: 'father',
      id: '',
      maxYears: new Date().getFullYear(),
      magIncludeFilter: [],
      allMagFilterOptions: [], // 推送期刊范围（接口获取）
      pushType: '',
      isFirstLoad: true,
      bookFilterOptions: [],
      loading: false
    }
  },
  components: {
    SubjectSelection
  },
  watch: {
    defaultPushType(val) {
      if (!val) {
        return
      }
      this.pushType = val || ''
    },
    titleCascaderValue(val) {
      if (val && val.length > 0) {
        const level1TitleMap = new Map()
        val.forEach((item) => {
          if (item.length === 1) {
            const level1 = item[0]
            if (!level1TitleMap.has(level1)) {
              level1TitleMap.set(level1, [])
            }
          } else if (item.length === 2) {
            const level1 = item[0]
            const level2 = item[1]
            if (!level1TitleMap.has(level1)) {
              level1TitleMap.set(level1, [])
            }
            level1TitleMap.get(level1).push(level2)
          }
        })

        this.levelTitle = Array.from(level1TitleMap.entries()).map(
          ([level1, level2List]) => ({
            level1Title: level1,
            level2Title: level2List.join(',')
          })
        )
      } else {
        this.levelTitle = []
      }
    },
    bookCascaderValue(val) {
      if (val && val.length > 0) {
        // val 为二维数组：[[code1, code2], [code3, code4]]
        // 仅保存每项的叶子节点 ID（路径最后一个 code）
        this.ruleForm.bookFilter = val.map((item) => item[item.length - 1])
      } else {
        this.ruleForm.bookFilter = []
      }
    },
    customSubjects() {
      if (this.customSubjects && this.customSubjects.length) {
        // 只传叶子节点名称，分号分隔
        this.ruleForm.customSubjects = this.customSubjects.join(';')
      } else {
        this.ruleForm.customSubjects = ''
      }
    }
  },
  computed: {
    ...mapGetters(['isMedicalAssociationEnv']),
    // 根据路由 type 参数区分推送类型：1整期 2专题 3通知 4单篇 5主题
    // 根据 isMedicalAssociationEnv 区分医学会/工信，返回默认值/最大值/提示语
    pushTypeConfig() {
      const type = Number(this.$route.query.type) || 0
      // 医学会版本（isMedicalAssociationEnv === true）
      const medicalMap = {
        1: { defaultCount: 1000, max: 1000, tips: '推送人数上限 1000人' },
        2: { defaultCount: 800, max: 1000, tips: '推送人数上限 1000人' },
        3: { defaultCount: 1000, max: 1000, tips: '推送人数上限 1000人' },
        4: { defaultCount: 200, max: 200, tips: '推送人数上限 200人' },
        5: { defaultCount: 1000, max: 1000, tips: '推送人数上限 1000人' }
      }
      // 工信/常规版本
      const normalMap = {
        1: {
          defaultCount: 10000,
          max: 50000,
          tips: '建议每期人数 10000~12000人'
        },
        2: {
          defaultCount: 10000,
          max: 50000,
          tips: '建议每次人数 10000~12000人'
        },
        3: {
          defaultCount: 10000,
          max: 50000,
          tips: '建议每次人数 10000~12000人'
        },
        4: { defaultCount: 1500, max: 50000, tips: '建议每次人数 1500~3000人' },
        5: {
          defaultCount: 10000,
          max: 50000,
          tips: '建议每次人数 10000~12000人'
        }
      }
      const fallback = this.isMedicalAssociationEnv
        ? { defaultCount: 1000, max: 1000, tips: '推送人数上限 1000人' }
        : {
            defaultCount: 10000,
            max: 50000,
            tips: '建议每次人数 10000~12000人'
          }
      const configMap = this.isMedicalAssociationEnv ? medicalMap : normalMap
      return configMap[type] || fallback
    },
    titleCascaderProps() {
      return {
        multiple: true,
        emitPath: true
      }
    },
    bookCascaderProps() {
      return {
        multiple: true,
        emitPath: true,
        checkStrictly: true
      }
    }
  },
  created() {
    if (this.$route.query.pushType) {
      this.pushType = Number(this.$route.query.pushType)
    }
    this.maxYears = new Date().getFullYear()
    this.initData()
  },
  methods: {
    /**
     * 学科级联根节点加载完成回调
     * Subject 抛出第一个根节点，取其 name 作为路径首项（替代写死的 'father'）
     * 若已有选中值且首项为旧占位，同步更新以支持 cascader 正确回显选中态
     */
    handleSubjectRootLoaded(rootNode) {
      this.subjectRootName = (rootNode && rootNode.name) || 'father'
    },
    pushTypeChange(pushType, forceUpdate) {
      // forceUpdate 为 true（来源于默认推送方式获取）时，跳过首次加载判断，直接执行
      if (forceUpdate || !this.isFirstLoad) {
        this.pushType = pushType || ''
        this.initData(this.pushType)
      }
    },
    async initData(pushType) {
      this.loading = true
      if (this.isMedicalAssociationEnv) {
        await this.getProfTitleList()
      } else {
        await Promise.all([this.getCategoryTree(), this.getAllMagFilter()])
      }
      await this.getFilterConfig(pushType)
      this.loading = false
    },
    async getCategoryTree() {
      const res = await Get(increment.getCategoryTree.url, {
        params: {
          historyId: this.historyId
        }
      })
      if (res.data.status === 0 && res.data.data) {
        this.bookFilterOptions =
          this.processCategoryTreeData(res.data.data) || []
      }
    },
    async getAllMagFilter() {
      const res = await Get(increment.GetAllMagFilter.url)
      if (res.data.status === 0 && res.data.data) {
        this.allMagFilterOptions = res.data.data || []
      }
    },
    // 推送期刊范围回显：接口返回的 { name, type } 映射为选项对象（兼容 JSON 字符串）
    echoMagIncludeFilter(list) {
      let filters = list
      if (typeof filters === 'string') {
        try {
          filters = JSON.parse(filters)
        } catch (error) {
          filters = []
        }
      }
      if (!Array.isArray(filters) || !filters.length) {
        this.magIncludeFilter = []
        return
      }
      this.magIncludeFilter = filters
        .map((item) =>
          this.allMagFilterOptions.find(
            (opt) => opt.name === item.name && opt.type === item.type
          )
        )
        .filter((item) => item)
    },
    getZxsFilterPayload() {
      return {
        magIncludeFilter: this.magIncludeFilter.map((item) => ({
          name: item.name,
          type: item.type
        })),
        articleYearFilter: this.ruleForm.articleYearFilter
      }
    },
    // 单独保存推送期刊范围/论文时间范围
    async saveZxsFilter() {
      const query = new URLSearchParams({
        historyId: this.historyId || '',
        zxsList: this.ruleForm.zxsFilter || ''
      }).toString()
      const res = await Post(
        increment.setZxsFilter.url + '?' + query,
        this.getZxsFilterPayload()
      )
      if (res.data.status !== 0) {
        throw new Error(res.data.message || '保存推送期刊范围失败')
      }
    },
    // 默认配置页保存推送期刊范围/论文时间范围
    async saveDefaultZxsFilter() {
      const query = new URLSearchParams({
        type: this.taskType,
        pushType: this.pushType || ''
      }).toString()
      const res = await Post(
        increment.setDefaultZxsFilter.url + '?' + query,
        this.getZxsFilterPayload()
      )
      if (res.data.status !== 0) {
        throw new Error(res.data.message || '保存推送期刊范围失败')
      }
    },
    processCategoryTreeData(data) {
      return data.map((item) => ({
        value: item.value,
        label: item.label,
        children:
          item.children && item.children.length > 0
            ? this.processCategoryTreeData(item.children)
            : null
      }))
    },
    async getFilterConfig(pushType) {
      let url = increment.GetFilterConfig.url
      const params = {}
      if (pushType) {
        url = increment.getDefaultFilter.url
        params.type = this.$route.query.type || ''
        params.pushType = this.pushType || ''
      } else {
        if (this.historyId) {
          url = increment.GetFilterConfig.url
          params.historyId = this.historyId
        } else if (this.subjectId) {
          url = increment.GetPushSubjectFilterConfig.url
          params.subjectId = this.subjectId
        } else {
          url = increment.getDefaultFilter.url
          params.type = this.taskType
          params.pushType = this.pushType || ''
        }
      }
      const res = await Get(url, {
        params
      })
      console.log(res)
      if (res.data.status === 0 && res.data.data) {
        console.log(pushType, 'pushType')
        if (!pushType) {
          this.id = res.data.data.id || ''
        }
        Object.keys(this.ruleForm).forEach((key) => {
          this.ruleForm[key] = res.data.data[key]
        })
        if (this.ruleForm.level1Title) {
          this.ruleForm.level1Title = ''
          this.ruleForm.level2Title = ''
        }
        if (res.data.data.levelTitle && res.data.data.levelTitle.length > 0) {
          this.$nextTick(() => {
            this.loadCascaderOptionsForEcho(res.data.data.levelTitle)
          })
        } else {
          this.titleCascaderValue = []
        }
        if (this.ruleForm.customSubjects) {
          // 回显：分号分隔的叶子名称数组，直接传给 Subject 组件
          this.customSubjects = this.ruleForm.customSubjects
            .split(';')
            .filter((s) => s)
        } else {
          this.customSubjects = []
        }
        if (this.ruleForm.bookFilter) {
          this.$nextTick(() => {
            this.loadBookCascaderOptionsForEcho(this.ruleForm.bookFilter)
          })
        } else {
          this.bookCascaderValue = []
        }
        // 推送期刊范围回显（getFilter 接口返回）
        this.echoMagIncludeFilter(res.data.data.magIncludeFilter)
        console.log(this.ruleForm, 'this.ruleForm')
      } else {
        // res.data.data 为空时清空表单
        Object.keys(this.ruleForm).forEach((key) => {
          if (Array.isArray(this.ruleForm[key])) {
            this.ruleForm[key] = []
          } else {
            this.ruleForm[key] = ''
          }
        })
        // 恢复默认值
        this.ruleForm.articleYearFilter = 5
        this.ruleForm.sendAuthorCount = this.pushTypeConfig.defaultCount
        // 重置关联字段
        this.customSubjects = []
        this.titleCascaderValue = []
        this.bookCascaderValue = []
        this.magIncludeFilter = []
        if (!pushType) {
          this.id = ''
        }
      }
      this.isFirstLoad = false
    },
    loadCascaderOptionsForEcho(levelTitleData) {
      const cascaderValue = []
      const level1Codes = [
        ...new Set(levelTitleData.map((item) => item.level1Title))
      ]

      level1Codes.forEach((level1) => {
        const item = levelTitleData.find((t) => t.level1Title === level1)
        if (item.level2Title) {
          const level2Titles = item.level2Title.split(',')
          level2Titles.forEach((level2) => {
            cascaderValue.push([level1, level2])
          })
        } else {
          cascaderValue.push([level1])
        }
      })

      console.log('titleCascaderOptions:', this.titleCascaderOptions)
      console.log('cascaderValue:', cascaderValue)

      this.cascaderKey++
      this.$nextTick(() => {
        this.$set(this, 'titleCascaderValue', cascaderValue)
      })
    },
    loadBookCascaderOptionsForEcho(bookFilter) {
      let cascaderValue = []
      if (Array.isArray(bookFilter)) {
        // bookFilter 存储的是叶子节点 ID 数组，如 ["B", "D"]
        // 需要从 options 树中查找完整路径
        cascaderValue = bookFilter
          .map((leafId) =>
            this.findPathByLeafId(this.bookFilterOptions, leafId)
          )
          .filter((path) => path.length > 0)
      } else if (typeof bookFilter === 'string' && bookFilter) {
        // 兼容旧字符串格式 "code1,code2;code3,code4"
        cascaderValue = bookFilter
          .split(';')
          .filter((item) => item)
          .map((item) => item.split(','))
      }
      this.bookCascaderKey++
      this.$nextTick(() => {
        this.$set(this, 'bookCascaderValue', cascaderValue)
      })
    },
    // 根据叶子节点 ID 在级联选项树中查找完整路径
    findPathByLeafId(options, leafId, path = []) {
      for (const node of options) {
        const currentPath = [...path, node.value]
        if (node.value === leafId) {
          return currentPath
        }
        if (node.children && node.children.length > 0) {
          const found = this.findPathByLeafId(
            node.children,
            leafId,
            currentPath
          )
          if (found.length > 0) return found
        }
      }
      return []
    },
    splitByIntegerPartWithUniqueValues(arr) {
      const result = []
      const map = new Map()

      arr.forEach((num) => {
        const intPart = Math.floor(Number(num)).toString() // 取整数部分作为分组 key
        if (!map.has(intPart)) {
          map.set(intPart, ['father']) // 新建分组
        }
        const group = map.get(intPart)
        if (!group.includes(num.toString())) {
          // 防止重复数字
          group.push(num.toString())
        }
      })

      // 保持输入顺序输出
      const seen = new Set()
      arr.forEach((num) => {
        const intPart = Math.floor(Number(num)).toString()
        if (!seen.has(intPart)) {
          result.push(map.get(intPart))
          seen.add(intPart)
        }
      })

      return result
    },
    submitForm() {
      return new Promise((resolve, reject) => {
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            console.log(this.ruleForm, 'this.ruleForm')
            let params = {
              ...this.ruleForm,
              levelTitle: this.levelTitle
            }
            if (this.id) {
              params.id = this.id
            }
            let url = ''
            let isDefaultFilter = false
            if (this.historyId) {
              url = increment.SaveFilterConfig.url
              params.historyId = this.historyId
            } else if (this.subjectId) {
              url = increment.SavePushSubjectFilterConfig.url
              params.subjectId = this.subjectId
            } else {
              url = increment.upsertDefaultFilter.url
              params.type = this.taskType
              params.pushType = this.pushType || ''
              isDefaultFilter = true
            }
            try {
              const res = await Post(url, params)
              if (res.data.status === 0) {
                if (!this.isMedicalAssociationEnv) {
                  if (this.historyId) {
                    await this.saveZxsFilter()
                  } else if (isDefaultFilter) {
                    await this.saveDefaultZxsFilter()
                  }
                }
                resolve(0)
                this.getFilterConfig()
              }
            } catch (error) {
              reject(error)
            }
          } else {
            console.log('error submit!!')
            reject('error submit!!')
          }
        })
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    async getProfTitleList() {
      try {
        const res = await Get(increment.GetProfTitleList.url, { params: {} })
        if (res.data.status === 0) {
          // 转换为级联选择器需要的格式，并预加载所有子节点
          const level1Items = res.data.data.map((item) => ({
            value: item.code,
            label: item.name,
            children: []
          }))

          // 批量加载所有二级职称
          for (const level1 of level1Items) {
            const childRes = await Get(increment.GetProfTitleList.url, {
              params: { code: level1.value }
            })
            if (childRes.data.status === 0) {
              level1.children = childRes.data.data.map((item) => ({
                value: item.code,
                label: item.name,
                leaf: true
              }))
            }
          }

          this.titleCascaderOptions = level1Items
        }
      } catch (error) {
        console.error('获取职称列表失败:', error)
      }
    },
    async loadChildTitle(node, resolve) {
      try {
        const res = await Get(increment.GetProfTitleList.url, {
          params: { code: node.value }
        })
        if (res.data.status === 0) {
          const children = res.data.data.map((item) => ({
            value: item.code,
            label: item.name,
            leaf: true
          }))
          resolve(children)
        } else {
          resolve([])
        }
      } catch (error) {
        console.error('获取职称列表失败:', error)
        resolve([])
      }
    },
    handleImportScholar({ file }) {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('taskId', this.historyId)
      Post(increment.importAuthorList.url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then((res) => {
          console.log(res.data, 'res.data')
          if (res.data.status === 0) {
            this.$message.success(
              '成功导入学者' + res.data.data.successCount + '人'
            )
          } else {
            this.$message.error(res.data.message || '导入失败')
          }
        })
        .catch(() => {
          this.$message.error('导入失败')
        })
    },
    downloadTemplate() {
      const url =
        this.$micro.WEBPACK_PUBLIC_PATH + '/static/作者数据导入示例文件.xlsx'
      const xhr = new XMLHttpRequest()
      xhr.open('GET', url, true)
      xhr.responseType = 'blob'
      xhr.onload = () => {
        if (xhr.status === 200) {
          const blob = xhr.response
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = '作者数据导入示例文件.xlsx'
          link.click()
          URL.revokeObjectURL(link.href)
        } else {
          this.$message.error('下载失败')
        }
      }
      xhr.onerror = () => {
        this.$message.error('下载失败')
      }
      xhr.send()
    }
  }
}
</script>

<style lang="scss" scoped>
.pushSettings {
  .tips {
    font-size: 12px;
    color: #909399;
    line-height: 14px;
  }
  ::v-deep .el-form-item__label {
    text-align: left;
    font-size: 14px;
  }
  .el-input,
  .el-select {
    max-width: 80%;
  }
  &__tips {
    font-size: 12px;
    color: #909399;
  }
  &__sendAuthorCount {
    .el-input-number {
      margin-right: 10px;
    }
  }
  .upload-demo {
    display: flex;
    align-items: center;
  }
}
</style>
